import { List } from "immutable"
import { DonationFormType } from "../cms/modernBlocks/blocks/donationFormBlock/donationFormBlock.state"
import { GtmProduct, pushDatalayer } from "./datalayer"

const donationButtonClickDataLayer = (label: 'form' | 'm-small-button' | 'm-image-expandable' | string) => (
  pushDatalayer({
    event: 'donation-button',
    category: 'donation-button',
    action: label == "form" ? 'standalone' : (label == "m-small-button" || label == "m-image-expandable") ? 'inline' : 'Direct aanmelden',
    label: label
  })
)

const donationCheckoutDataLayer = (step: 1 | 2 | 3, donationFormType: DonationFormType, frequency: string, products: GtmProduct[]) => (
  pushDatalayer({
    event: 'checkout',
    ecommerce: {
      checkout: {
        actionField: {
          step: step,
          donationFrequency: frequency
        },
        products: products
      }
    },
    events: {
      category: 'ecommerce',
      action: 'checkout',
      label: donationFormType,
    },
  })
)

const transactionCheckoutDataLayer = (amount: string, transactionId: string, frequency: string, products: GtmProduct[]) => (
  pushDatalayer({
    event: 'transaction',
    ecommerce: {
      currencyCode: 'EUR',
      purchase: {
        actionField: {
          id: transactionId,
          revenue: amount,
          donationFrequency: frequency,
          'opt-in': 'no',
        },
        products: products,
      },
    },
    events: {
      category: 'ecommerce',
      action: 'transaction',
    },
  })
)

const donationFormDataLayer = (id: string, label: string) => (
  pushDatalayer({
    event: 'donation-form',
    category: 'donation-form',
    action: `fo-${id}`,
    label: label
  })
)

const scheduleDonationCheckoutDataLayer = (step: 1 | 2 | 3, donationFormType: DonationFormType, frequency: string, products: GtmProduct[]) => (
  schedulePushDatalayer({
    event: 'checkout',
    ecommerce: {
      checkout: {
        actionField: {
          step: step,
          donationFrequency: frequency
        },
        products: products
      }
    },
    events: {
      category: 'ecommerce',
      action: 'checkout',
      label: donationFormType,
    },
  })
)

const scheduleTransactionCheckoutDataLayer = (amount: string, transactionId: string, frequency: string, products: GtmProduct[]) => (
  schedulePushDatalayer({
    event: 'transaction',
    ecommerce: {
      currencyCode: 'EUR',
      purchase: {
        actionField: {
          id: transactionId,
          revenue: amount,
          donationFrequency: frequency,
          'opt-in': 'no',
        },
        products: products,
      },
    },
    events: {
      category: 'ecommerce',
      action: 'transaction',
    },
  })
)

const scheduleSuccessDataLayer = (label: string) => (
  schedulePushDatalayer({
    event: 'donation-form',
    category: 'donation_form',
    flow: 'donatie_voltooid',
    label: label,
  })
)

const schedulePushDatalayer = (data: {}) => {
  let gtmPush = window.localStorage.getItem("gtmPush")

  let gtmPushJson: Array<{}> = JSON.parse(gtmPush || "[]")
  const gtmPushList = List(gtmPushJson)
  const newList = gtmPushList.push(data)

  window.localStorage.setItem("gtmPush", JSON.stringify(newList.toArray()))
}

const sendPendingGtmEvents = () => {
  // const url = new URL(document.location.toString())
  // const paymentSuccess = url.searchParams.get("paymentSuccess") == "true"
  // if (!paymentSuccess) return window.localStorage.removeItem("gtmPush")

  let gtmPush = window.localStorage.getItem("gtmPush")
  let gtmPushJson: Array<{}> = JSON.parse(gtmPush || "[]")

  gtmPushJson.forEach(gtm => {
    pushDatalayer(gtm)
  })
  window.localStorage.removeItem("gtmPush")
}


const propositionPagePushDatalayer = (amount: number, propositionIndex: number) => {
  pushDatalayer({
    event: "donation_blocks",
    amount: `${amount}`,
    flow: "stap 1",
    package: `${propositionIndex}`,
    page_path: location.pathname,
  })
}

const propositionDonationFormStartPushDatalayer = () => {
  pushDatalayer({
    event: "donation_blocks",
    flow: "stap 2 - form start",
  })
}

const propositionDonationFormDonatePushDatalayer = (optin: boolean) => {
  pushDatalayer({
    event: "donation_blocks",
    flow: "stap 2 - button doneer nu",
    "email_opt-in": optin ? "ja" : "no"
  })
}

export const donationDataLayerServices = {
  donationButtonClickDataLayer,
  donationFormDataLayer,
  donationCheckoutDataLayer,
  transactionCheckoutDataLayer,
  scheduleDonationCheckoutDataLayer,
  scheduleTransactionCheckoutDataLayer,
  scheduleSuccessDataLayer,
  sendPendingGtmEvents,
  propositionPagePushDatalayer,
  propositionDonationFormStartPushDatalayer,
  propositionDonationFormDonatePushDatalayer,
}
